import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'src/api/axiosInstance';

export const fetchSetupChecklist = createAsyncThunk(
  'setupChecklist/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get('/rest/admin/setup-checklist');
      return response.data;
    } catch (err) {
      console.error('[SetupChecklist] Failed to fetch:', err);
      return rejectWithValue(err?.response?.data?.message || 'Failed to fetch setup checklist');
    }
  },
  {
    condition: (_, { getState }) => {
      const { setupChecklist } = getState();
      // Don't re-fetch if already initialized and not invalidated
      if (setupChecklist?.initialized && !setupChecklist?.loading) return false;
      // Don't double-fetch
      if (setupChecklist?.loading) return false;
      return true;
    },
  }
);

export const dismissChecklistItem = createAsyncThunk(
  'setupChecklist/dismiss',
  async (key, { rejectWithValue }) => {
    try {
      await axiosInstance.post('/rest/admin/setup-checklist/dismiss', { key });
      return key;
    } catch (err) {
      console.error('[SetupChecklist] Failed to dismiss:', err);
      return rejectWithValue(err?.response?.data?.message || 'Failed to dismiss item');
    }
  }
);

export const restoreChecklistItem = createAsyncThunk(
  'setupChecklist/restore',
  async (key, { dispatch, rejectWithValue }) => {
    try {
      await axiosInstance.delete(`/rest/admin/setup-checklist/dismiss/${key}`);
      // Invalidate cache first so fetch actually runs
      dispatch({ type: 'setupChecklist/invalidateSetupChecklist' });
      dispatch(fetchSetupChecklist());
      return key;
    } catch (err) {
      console.error('[SetupChecklist] Failed to restore:', err);
      return rejectWithValue(err?.response?.data?.message || 'Failed to restore item');
    }
  }
);

export const remindLaterChecklist = createAsyncThunk(
  'setupChecklist/remindLater',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      await axiosInstance.post('/rest/admin/setup-checklist/remind-later');
      // Invalidate cache first so fetch actually runs
      dispatch({ type: 'setupChecklist/invalidateSetupChecklist' });
      dispatch(fetchSetupChecklist());
      return true;
    } catch (err) {
      console.error('[SetupChecklist] Failed to snooze:', err);
      return rejectWithValue(err?.response?.data?.message || 'Failed to snooze checklist');
    }
  }
);
